import { cn } from '@/lib/utils';
import Typography from '@ui/Typography';
import { cx } from 'cva';
import React from 'react';
import Tooltip from '../Tooltip';
import { BiInfoCircle } from 'react-icons/bi';
import ClickableTooltip from '@/components/Styled/ClickableTooltip';

function Input(props, ref) {
  const {
    label,
    placeholder,
    required,
    className,
    type = 'text',
    error,
    adornment,
    tooltip,
    ...rest
  } = props;
  const hasError = !!error;

  return (
    <div className="flex w-full flex-col gap-1">
      {label && (
        <div className="flex items-center justify-start gap-0.5">
          <Typography
            variant="h5"
            className="uppercase"
            component="label"
            htmlFor={label}>
            {label}
          </Typography>
          {required && (
            <Typography variant="h5" component="span" color="error">
              *
            </Typography>
          )}

          {/* {tooltip && (
            <Tooltip content={tooltip}>
              <BiInfoCircle className="ml-2 text-text-secondary" />
            </Tooltip>
          )} */}

          {tooltip && <ClickableTooltip message={tooltip} />}
        </div>
      )}
      <div className="relative w-full">
        <input
          ref={ref}
          id={label || 'input'}
          className={cn(
            'focus:shadow-outline w-full rounded-lg bg-primary-light-1 px-6 py-3 font-poppins text-14 text-text-primary focus:outline-none',
            hasError && 'border border-error',
            className,
          )}
          placeholder={placeholder || label}
          type={type}
          {...rest}
        />
        {adornment && (
          <div className="absolute left-0 top-0 flex h-full items-center justify-start pl-2">
            {adornment}
          </div>
        )}
      </div>
      {hasError && (
        <Typography variant="caption" color="error">
          {error}
        </Typography>
      )}
    </div>
  );
}

export default React.forwardRef(Input);
